import cx from "classnames";
import NextImage from "next/image";
import css from "./Image.module.css";
import { getImageUrl } from "utils";
import { ImageProviderTypes } from "@forcode/domain";

export type ICommonImageProps = {
  alt: string;
  src: string;
  width: number;
  height: number;
  priority?: boolean;
  loading?: "lazy" | "eager";
};

export interface IImageProps {
  className?: string;
  position?: "centered";
  showCaption?: boolean;
  provider?: ImageProviderTypes;
}

export type Props = ICommonImageProps & IImageProps;

const BASE_CLASS = "f-AtomImage";

export const Image = ({
  alt,
  className,
  position,
  provider = "default",
  priority = false,
  loading,
  showCaption = false,
  src,
  width,
  height,
}: Props) => {
  const classNames = cx(css[BASE_CLASS], {
    [css[`${BASE_CLASS}-position--centered`]]: position === "centered",
    [`${className}`]: Boolean(className),
  });

  const url = provider === "cloudinary" ? getImageUrl({ src }) : src;

  return (
    <picture className={classNames}>
      <NextImage
        src={url}
        alt={alt}
        width={width}
        height={height}
        priority={priority}
        loading={loading}
      />
      {showCaption && <figcaption>{alt}</figcaption>}
    </picture>
  );
};
